module.exports = __webpack_public_path__ + "static/media/testsInc.7f987da2.png";